<ng-container>
  <ejs-dialog
    [allowDragging]="true"
    [enableResize]="true"

    [visible]="createUserDialogOpened$ | async"

    [showCloseIcon]="true"

    [width]="'45%'"
    [height]="'55%'"
    [zIndex]="800"

    (close)="closeCreateUserDialog()"

  >
    <ng-template #header>
      <span appFlex="auto">
        {{ "Ajout d'un utilisateur" | translate }}
      </span>
    </ng-template>

    <form [formGroup]="userCreateForm" autocomplete="none">

      <ng-template #content>

        <mat-tab-group class="h-100-p">
          <mat-tab label="{{'Infos' | translate}}" class="tab-container-full-height">
            <ng-template matTabContent>

              <div class="row mt-4">

                <mat-form-field class="w-50-p pr-4">
                  <mat-label>{{ "Langue de l'utilisateur" | translate }}</mat-label>
                  <mat-select formControlName="lang">
                    <mat-option *ngFor="let type of availableLang" [value]="type.value">
                      {{ type.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="userCreateForm.get('lang').invalid">
                    {{ displayAccountTypeErrorMsg() | translate }}
                  </mat-error>
                </mat-form-field>


                <div class="w-100-p">
                  <mat-checkbox [formControl]="userCreateForm.get('newOrganization')" class="block">
                    {{ 'Nouvelle organisation'|translate }}
                  </mat-checkbox>

                </div>

                <mat-form-field class="w-100-p pl-4">
                  <mat-label>{{ 'Nom de l\'organisation' | translate }}</mat-label>

                  <ng-container *ngIf="!userCreateForm.get('newOrganization').value">
                    <input type="text" matInput [matAutocomplete]="auto" formControlName="organization">
                    <mat-autocomplete [displayWith]="organizationDisplayFn.bind(this)" #auto="matAutocomplete">
                      <mat-option *ngFor="let organization of filteredOrganizations$ | async" [value]="organization.id">
                        {{ organization.name }}
                      </mat-option>
                    </mat-autocomplete>
                  </ng-container>
                  <ng-container *ngIf="userCreateForm.get('newOrganization').value">
                    <input type="text" matInput formControlName="organization">
                  </ng-container>

                  <mat-error *ngIf="userCreateForm.get('organization').invalid">
                    {{ displayOrganizationErrorMsg() | translate }}
                  </mat-error>

                </mat-form-field>
              </div>

              <div class="row">
                <mat-form-field class="w-50-p pr-4">
                  <mat-label>{{ 'Prénom' | translate }}</mat-label>
                  <input matInput type="text" formControlName="firstName">
                  <mat-error *ngIf="userCreateForm.get('firstName').invalid">
                    {{ displayFirstNameErrorMsg() | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-50-p pl-4">
                  <mat-label>{{ 'Nom' | translate }}</mat-label>
                  <input matInput type="text" formControlName="lastName">
                  <mat-error *ngIf="userCreateForm.get('lastName').invalid">
                    {{ displayLastNameErrorMsg() | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="row">

                <mat-form-field class="w-50-p pr-4">
                  <mat-label>{{ 'Courriel' | translate }}</mat-label>
                  <input matInput type="email" formControlName="email">
                  <mat-error *ngIf="userCreateForm.get('email').invalid">
                    {{ displayEmailErrorMsg() | translate }}
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-50-p pr-4">
                  <mat-label>{{ "Mot de passe" | translate }}</mat-label>
                  <input matInput type="password" formControlName="password" autocomplete="new-password">
                  <mat-error *ngIf="userCreateForm.get('password').invalid">
                    {{ displayPasswordErrorMsg() | translate }}
                  </mat-error>
                </mat-form-field>

                <!--                <mat-form-field class="w-50-p pl-4">-->
                <!--                  <mat-label>{{"Confirmation du mot de passe" | translate}}</mat-label>-->
                <!--                  <input matInput type="password" placeholder="{{'Confirmez le mot de passe' | translate}}" formControlName="passwordConfirmation" autocomplete="off">-->
                <!--                  <mat-error *ngIf="userCreateForm.get('passwordConfirmation').invalid">-->
                <!--                    {{ displayPasswordConfirmationErrorMsg() | translate }}-->
                <!--                  </mat-error>-->
                <!--                </mat-form-field>-->

              </div>

              <div class="row">
                <pre>{{ userRolesSelected|json }}</pre>
              </div>

            </ng-template>

          </mat-tab>
          <mat-tab label="{{'Rôles' | translate}}" class="tab-container-full-height">
            <ng-template matTabContent>

              <div class="grid-container">

                <app-user-client-roles-selector
                  class="mt-4"
                  style="max-height: 350px;"
                  [defaultUserRoles]="userRolesSelected"
                  (userRolesChanged)="userRolesChanged($event)"
                >
                </app-user-client-roles-selector>

                <!--                <dx-data-grid-->
                <!--                  [height]="'100%'"-->
                <!--                  [width]="'100%'"-->

                <!--                  [hoverStateEnabled]="true"-->
                <!--                  keyExpr="role"-->

                <!--                  [(selectedRowKeys)]="userRolesSelected"-->

                <!--                  [dataSource]="userRolesKeyValue"-->

                <!--                  [columnAutoWidth]="true"-->

                <!--                  [allowColumnReordering]="true"-->
                <!--                  [allowColumnResizing]="true"-->

                <!--                  [showColumnLines]="false"-->
                <!--                  [showRowLines]="false"-->
                <!--                  [showBorders]="true"-->
                <!--                  [rowAlternationEnabled]="false"-->

                <!--                >-->

                <!--                  <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>-->

                <!--                  <dxo-search-panel [visible]="true" [width]="'70%'" [placeholder]="'Rechercher...' | translate"></dxo-search-panel>-->
                <!--                  <dxo-filter-panel [visible]="true"></dxo-filter-panel>-->
                <!--                  <dxo-group-panel [visible]="false"></dxo-group-panel>-->

                <!--                  <dxo-scrolling mode="virtual" useNative="true" showScrollbar="always"></dxo-scrolling>-->

                <!--                </dx-data-grid>-->

              </div>
            </ng-template>

          </mat-tab>
        </mat-tab-group>

      </ng-template>

    </form>

    <ng-template #footerTemplate>
      <button
        mat-raised-button color="primary"
        (click)="createUser()"
        [disabled]="userCreateForm.invalid"
      >
        {{ 'Enregistrer' | translate }}
      </button>
    </ng-template>

  </ejs-dialog>
</ng-container>
